// =============================================================================
// LEADCONVERSION.JS — Turning a CRM lead into a deal.
// =============================================================================
// The lead and deal tables name the same concepts differently. Getting this
// mapping wrong is silent: the deal form simply opens with blank fields and the
// agent retypes everything, or worse, saves a deal with no brand on it.
//
//   leads.brand         -> deals.brand
//   leads.client        -> deals.client
//   leads.contact_name  -> deals.contact_person
//   leads.contact_email -> deals.email          (NOT contact_email)
//   leads.estimated_value -> deals.deal_amount
//   leads.notes         -> deals.notes
//
// There is no lead field for `creator` — that is chosen when the deal is filled
// in, so it is deliberately left blank rather than guessed.
// =============================================================================

/**
 * Build the DealModal prefill for a lead being converted.
 * @param {object} lead        Row from the `leads` table.
 * @param {object} currentUser Profile of whoever is converting.
 * @returns {object} prefill merged over DealModal's defaults.
 */
export function leadToDealPrefill(lead, currentUser) {
  if (!lead) return null
  return {
    date: new Date().toISOString().slice(0, 10),
    brand: lead.brand || '',
    // Fall back to the brand when no agency/client is recorded — a deal with a
    // blank client is harder to find later than one that repeats the brand.
    client: lead.client || lead.brand || '',
    contact_person: lead.contact_name || '',
    email: lead.contact_email || '',
    deal_amount: lead.estimated_value || 0,
    notes: lead.notes || '',
    // The lead belongs to its owner, not to whoever happens to be looking at
    // it, so the deal starts on the owner and only falls back to the converter.
    agent: lead.owner_name || currentUser?.agent_name || '',
    status: 'Concept',
    source_lead_id: lead.id || null,
  }
}

/** True when `deals` already contains a deal converted from `lead`. */
export function isLeadConverted(lead, deals) {
  if (!lead?.id || !deals?.length) return false
  return deals.some(d => d.source_lead_id === lead.id)
}
